import {
    Autocomplete,
    Button, Checkbox,
    DialogActions,
    DialogContent, FormControlLabel,
    Grid,
    MenuItem,
    TextField,
} from "@mui/material";
import CommonModal from "../CommonModal";
import {isEmpty} from "../../Utils/CommonUtils";
import {LoadingButton} from "@mui/lab";

export default function ModalComponent(props) {
    const errors = props.errors || {};

    let getContent = () => {
        return (
            <>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField fullWidth
                                       disabled={props.update}
                                       name="parameterName"
                                       label="Name"
                                       value={props.currentParameter.parameterName}
                                       error={!isEmpty(errors.parameterName)}
                                       helperText={errors.parameterName || ''}
                                       onChange={props.handleChangeParameter}>
                                {props.currentParameter.parameterName}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.currentParameter.isMain}
                                        onChange={props.handleChangeIsMain}
                                        name="isMain"
                                    />
                                }
                                label="Is main"
                            />


                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete

                                multiple
                                value={props.currentParameter.allowedRules}
                                options={props.audience_options}
                                onChange={(e, v) =>
                                    props.handleChangeAllowedRules(v)}
                                renderInput={params => (
                                    <TextField {...params}
                                               fullWidth
                                               label="Type"
                                               error={!isEmpty(errors.allowedRules)}
                                               helperText={errors.allowedRules || ''}
                                    />
                                )}>

                            </Autocomplete>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="allowedValues"
                                label="Allowed values"
                                value={props.currentParameter.allowedValues ? props.currentParameter.allowedValues.join(',') : "www"}
                                onChange={props.handleChangeAllowedValues}
                                fullWidth
                                helperText='Comma separated array'/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={props.saveParameterResponse.isLoading} variant={'contained'} onClick={props.handleSave}>
                        Save
                    </LoadingButton>
                </DialogActions>
            </>
        )
    }

    return (
        <>
            <CommonModal
                open={props.open}
                handleDialogClose={props.handleDialogClose}
                title={props.title}
                content={getContent()}
            />
        </>
    )

}